// External jQuery
import $ from 'jquery';
import '@babel/polyfill/dist/polyfill';
import { updateLocation } from './_google_map';

$( document ).ready( function() {
	// eslint-disable-next-line no-console
	console.log( 'Everything is ready. ThemePlate!' );

	// Load the current location
	$( '#current-location' ).click( () => updateLocation() );
	$( '#reset-filters' ).click( () => {
		const url = new URL( window.location.origin + window.location.pathname );

		url.searchParams.delete( 'latitude' );
		url.searchParams.delete( 'longitude' );

		window.history.replaceState( null, null, url );
		$( '#alternate-address' ).val( '' );
		FWP.reset();
	} );
} );
